import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BookOpen, Home, MessageCircle, Play, ShoppingBag } from 'lucide-react';

import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import apiClient from '../../utils/api-client';
import './NavLinks.css';

const NavLinks = () => {
  const [isOpen, setIspen] = useState(false);
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const pathname = location.pathname; // eg: /category/household-items
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  // path ko split kar k last part nikal lena
  const currentCategory = pathname.split('/').pop();

  useEffect(() => {
    apiClient
      .get('/category')
      .then((res) => {
        setCategories(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const navItems = [
    {
      path: '/',
      label: 'Home',
      icon: Home,
      description: 'Back to homepage',
    },
    {
      path: '/shop',
      label: 'Shop',
      icon: ShoppingBag,
      description: 'Browse our products',
    },
    {
      path: '/blogs',
      label: 'Blog',
      icon: BookOpen,
      description: 'Read our latest articles',
    },
    {
      path: '/contact',
      label: 'Contact',
      icon: MessageCircle,
      description: 'Get in touch with us',
    },
    {
      path: '/videos',
      label: 'Videos',
      icon: Play,
      description: 'Watch our video content',
    },
  ];
  return (
    <div className="container-fluid">
      <div className="row align-items-center">
        {/* Left: Categories Dropdown */}
        <div className="col-lg-3 col-md-12 d-flex align-items-center">
          <div className="category-dropdown-wrapper w-100">
            <div
              className="dropdown-toggle-custom"
              onClick={() => setIspen(!isOpen)}
            >
              <div className="btn-content">
                <span>
                  {currentCategory ? currentCategory : selectedCategory}
                </span>
              </div>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`dropdown-chevron ${isOpen ? 'rotate' : ''}`}
              />
            </div>

            <div className={`dropdown-menu-custom ${isOpen ? 'show' : ''}`}>
              {categories &&
                categories.map((category, index) => (
                  <div className="dropdown-item-custom" key={index}>
                    <Link
                      onClick={() => {
                        setSelectedCategory(category.p_category_name);
                        setIspen(false);
                      }}
                      to={`/category/${category.slug}`}
                      className="dropdown-link"
                    >
                      <span>{category.p_category_name}</span>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* Right: Nav Links */}
        <div className="col-md-9 nav_links d-none d-lg-block">
          <ul className="nav justify-content-lg-end justify-content-center align-items-center">
            {navItems.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <li key={index} className="nav-item">
                  <NavLink
                    className="nav-link pro-nav-link"
                    to={item.path}
                    title={item.description}
                  >
                    <div className="nav-link-content d-flex align-items-center gap-2">
                      <IconComponent
                        size={16}
                        className="nav-icon"
                        strokeWidth={1.5}
                      />
                      <span className="nav-text">{item.label}</span>
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default NavLinks;
